
export const initZDSFooter = () => {
  if (zr.page.model.isZDS) {
    $('.zds .primary_footer_nav .group_header').on('click', (e) => {
      const $section = $(e.currentTarget);

      const show = !$section.hasClass('showing');
      $('.primary_footer_nav .group_header').removeClass('showing');
      $section.toggleClass('showing', show);
    });
  }
};

export default initZDSFooter;
